import React, { useEffect, useState } from "react";
import AdminSidebar from "./AdminSidebar";
import AdminHeader from "./AdminHeader";
import toast from "react-hot-toast";
import axios from "axios";
import { base_url } from "./AgentWhitelist";

function Currency() {
  const [currencyName, setCurrencyName] = useState("");
  const [list, setList] = useState([]);

  const [isSidebarOpen, setIsSidebarOpen] = useState(!(window.innerWidth < 768));
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  const [editId, setEditId] = useState(null);
  const [editCurrency, setEditCurrency] = useState("");

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  // 💥 TOKEN
  const auth = localStorage.getItem("admin");

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      if (!mobile) setIsSidebarOpen(true);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // 👉 Fetch Currency List (AUTH ADDED)
  const getCurrency = async () => {
    try {
      const res = await axios.get(`${base_url}/api/get-currency`, {
        withCredentials: true,
        headers: {
          "content-type": "application/json",
          Authorization: auth, // 🔥 TOKEN HERE
        },
      });

      const data = Array.isArray(res.data) ? res.data : [];
      setList(data);

    } catch (err) {
      console.log("GET ERROR:", err);
      setList([]);
    }
  };

  // 👉 Add Currency (AUTH ADDED)
const addCurrency = async (e) => {
  e.preventDefault();

  try {
    const res = await axios.post(
      `${base_url}/api/add-currency`,
      { currency: currencyName },
      {
        withCredentials: true,
        headers: {
          Authorization: auth,
          "content-type": "application/json",
        },
      }
    );

    toast.success(res.data.msg || "Currency added successfully!");

  } catch (err) {
    toast.error(err.response?.data?.msg || "Something went wrong");
  }
};


  // 👉 Delete Currency (AUTH ADDED)
const deleteCurrency = async (id) => {
  if (!window.confirm("Are you sure?")) return;

  try {
    await axios.delete(`${base_url}/api/delete-currency/${id}`, {
      withCredentials: true,
      headers: {
        Authorization: auth,
      },
    });

    toast.success("Currency deleted successfully!");
    getCurrency();
  } catch (err) {
    console.log(err);
    toast.error(err.response?.data?.msg || "Delete failed");
  }
}

  // 👉 Open Edit Modal
  const openEditModal = (row) => {
    setEditId(row.id);
    setEditCurrency(row.currency);
  };

  // 👉 Update Currency (AUTH ADDED)
  
const updateCurrency = async () => {
  if (!editCurrency) {
    toast.error("Enter currency!");
    return;
  }

  try {
    await axios.put(
      `${base_url}/api/update-currency/${editId}`,
      { currency: editCurrency },
      {
        withCredentials: true,
        headers: {
          Authorization: auth,
          "content-type": "application/json",
        },
      }
    );

    toast.success("Currency updated successfully!");

    setEditId(null);
    setEditCurrency("");
    getCurrency();

  } catch (err) {
    console.log(err);
    toast.error("Update failed!");
  }
};

  useEffect(() => {
    getCurrency();
  }, []);

  return (
    <div className="wrapper bg-light">
      <AdminSidebar
        isSidebarOpen={isSidebarOpen}
        toggleSidebar={toggleSidebar}
        isMobile={isMobile}
      />

      <AdminHeader
        toggleSidebar={toggleSidebar}
        isSidebarOpen={isSidebarOpen}
        isMobile={isMobile}
      />

      <div
        className={`content-wrapper p-1 ${
          !isMobile && isSidebarOpen ? "" : "open-content-wrapper"
        }`}
        style={{ marginLeft: !isMobile && isSidebarOpen ? "" : "0" }}
      >
        <div className="main-content">
          <div className="container-fluid py-4">
            <h3 className="text-dark mb-4">Currency Management</h3>

            {/* ADD FORM */}
            <form onSubmit={addCurrency} className="mb-4">
              <div className="mb-3">
                <label className="form-label">Currency Name</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter currency name"
                  value={currencyName}
                  onChange={(e) => setCurrencyName(e.target.value)}
                />
              </div>
              <button className="btn btn-primary">Add Currency</button>
            </form>

            {/* TABLE */}
            <div className="table-responsive shadow-sm bg-white p-3">
              <table className="table table-bordered table-striped">
                <thead>
                  <tr>
                    {/* <th>ID</th> */}
                    <th>Currency</th>
                    <th>Actions</th>
                  </tr>
                </thead>

                <tbody>
                  {list.length === 0 ? (
                    <tr>
                      <td colSpan={3} className="text-center text-muted">
                        No Record Found
                      </td>
                    </tr>
                  ) : (
                    list.map((row) => (
                      <tr key={row.id}>
                        {/* <td>{row.id}</td> */}
                        <td>{row.currency}</td>
                        <td>
                          <button
                            className="btn btn-warning btn-sm me-2"
                            onClick={() => openEditModal(row)}
                          >
                            Edit
                          </button>

                          <button
                            className="btn btn-danger btn-sm"
                            onClick={() => deleteCurrency(row.id)}
                          >
                            Delete
                          </button>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>

            {/* EDIT MODAL */}
            {editId && (
              <div
                className="modal fade show"
                style={{ display: "block", background: "rgba(0,0,0,0.5)" }}
              >
                <div className="modal-dialog">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title">Edit Currency</h5>
                      <button
                        className="btn-close"
                        onClick={() => setEditId(null)}
                      ></button>
                    </div>

                    <div className="modal-body">
                      <input
                        type="text"
                        className="form-control"
                        value={editCurrency}
                        onChange={(e) => setEditCurrency(e.target.value)}
                      />
                    </div>

                    <div className="modal-footer">
                      <button
                        className="btn btn-secondary"
                        onClick={() => setEditId(null)}
                      >
                        Cancel
                      </button>

                      <button className="btn btn-primary" onClick={updateCurrency}>
                        Update
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}

          </div>
        </div>
      </div>
    </div>
  );
}

export default Currency;
